module.exports = __webpack_public_path__ + "static/media/no_coupon_pack.f87ea969.png";